@use "../../custom-scroll/custom-scroll" as *;
@use "../revamp-table" as *;
@use "../../../design-tokens/border-radius/border-radius" as *;
@use "../../../design-tokens/typography/typography" as *;

@layer design-system {
  .container {
    flex: 1;
    width: 100%;
    height: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
  }

  .cellWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: var(--text-default);
  }

  .negative {
    color: var(--viz-bearish);
  }

  .positive {
    color: var(--viz-bullish);
  }

  .successStatus {
    padding: 2px 8px;
    border-radius: border-radius(r1);
    color: var(--viz-bullish);
    background-color: var(--viz-bullish-soft);
  }

  .failedStatus {
    padding: 2px 8px;
    border-radius: border-radius(r1);
    color: var(--viz-bearish);
    background-color: var(--viz-bearish-soft);
  }

  .cellInner {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: max-content;

    img {
      border-radius: border-radius(full);
      width: 20px;
      height: 20px;
      overflow: hidden;
    }
  }

  .entityCell {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .entityLogo {
    flex-shrink: 0;
    border-radius: border-radius(full);
    width: 28px;
    height: 28px;
    overflow: hidden;
    background-color: var(--surface-inverse);
    object-fit: cover;
  }

  .entityText {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
  }

  .entityName {
    @include typography-v2-body-sm;

    width: 100%;
    max-width: 212px;
    overflow: hidden;
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: var(--font-nort);
    color: var(--text-default);
  }

  .entityTicker {
    @include typography-v2-body-xs;
    overflow: hidden;
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: var(--font-nort);
    color: var(--text-soft);
  }

  .wrapper {
    overflow: auto;
    @include custom-scroll-minimal;
    width: 100%;
    position: relative;
    border-radius: border-radius(r2);

    &[data-show-border="true"] {
      border: 1px solid var(--border-soft);
    }

    // A custom header sits directly above the table and supplies the top
    // edge, so square the wrapper's top corners and drop its top border to
    // merge the two. Without a header the wrapper keeps its full border.
    &[data-custom-header="true"] {
      border-top-left-radius: 0;
      border-top-right-radius: 0;

      &[data-show-border="true"] {
        border-top: none;
      }
    }
  }

  .styledRevampTable {
    @include revamp-table;
    position: relative;
    border-radius: border-radius(r2);
    width: 100%;
    max-width: 100%;

    thead {
      width: 100%;
      table-layout: fixed;

      th {
        min-width: 116px;
      }

      th.headerCell {
        padding: 12px;
      }
    }

    td {
      padding: 12px;
      min-width: 148px;
    }

    &[data-custom-header="true"] td {
      padding: 6px 12px;
    }

    tbody tr {
      width: 100%;
      table-layout: fixed;

      td {
        min-width: 116px;
      }
    }
  }

  .root {
    @include revamp-table;
  }

  .withBodyRowCursor {
    @include revamp-table-body-row-cursor;
  }

  .withBodyRowHover {
    @include revamp-table-body-row-hover;
  }

  .buttonWrapper {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
  }
}
